import {
    ADD_TRADE_IN,
    DELETE_TRADE_IN,
    UNDO_DELETED_TRADE_IN,
    INCLUDE_TRADE_INS_CHANGED,
    TOGGLE_TRADE_IN_ACCORDION_STATE,
    TRADE_INS_ACV_CHANGED,
    TRADE_INS_ALLOWANCE_CHANGED,
    TRADE_INS_DETAILS_MANUAL_ENTRY_SAVE,
    TRADE_INS_PAYOFF_CHANGED,
    TRADE_INS_UPDATE_DOORS,
    TRADE_INS_UPDATE_DRIVE_LINE,
    TRADE_INS_UPDATE_IS_BUYER_REGISTERED_OWNER,
    TRADE_INS_UPDATE_IS_SELLING_VEHICLE_REGISTERED_IN_SAME_STATE,
    TRADE_INS_UPDATE_LIENHOLDER_FULL,
    TRADE_INS_UPDATE_ODOMETER,
    TRADE_INS_UPDATE_STOCK_NUMBER,
    TRADE_INS_UPDATE_YEAR,
    TRADE_INS_UPDATE_MAKE,
    TRADE_INS_UPDATE_MODEL,
    TRADE_INS_UPDATE_TRIM,
    TRADE_INS_UPDATE_EXTERIOR_COLOR,
    TRADE_INS_UPDATE_CONDITION,
    TRADE_INS_UPDATE_ENGINE,
    TRADE_INS_UPDATE_TRANSMISSION,
    TRADE_INS_UPDATE_BODY_STYLE,
    TRADE_INS_UPDATE_INTERIOR_COLOR,
    TRADE_INS_UPDATE_OWNERSHIP_TYPE,
    TRADE_INS_UPDATE_VIN,
    TRADE_INS_VIN_REQUEST,
    TRADE_INS_VIN_SUCCESS,
    TRADE_INS_VIN_FAILURE,
    TRADE_INS_MULTIPLE_VIN_SELECTED,
    TRADE_INS_COMPONENT_UPDATE_VEHICLE,
    TRADE_INS_MAKES_REQUEST,
    TRADE_INS_MAKES_SUCCESS,
    TRADE_INS_MAKES_FAILURE,
    TRADE_INS_VEHICLES_REQUEST,
    TRADE_INS_VEHICLES_SUCCESS,
    TRADE_INS_VEHICLES_FAILURE,
    TRADE_INS_UPDATE_MAKE_ID,
    TRADE_INS_MODELS_REQUEST,
    TRADE_INS_MODELS_SUCCESS,
    TRADE_INS_MODELS_FAILURE,
    TRADE_INS_UPDATE_MODEL_ID,
    TRADE_INS_TRIMS_REQUEST,
    TRADE_INS_TRIMS_FAILURE,
    TRADE_INS_TRIMS_SUCCESS
} from '../actionTypes/tradesActionTypes';
import type { ITradeIn } from '@makemydeal/dr-platform-types';
import type { TradeAction } from '../types/tradeInTypes';
import { scopedActionsCreators } from '@makemydeal/shared-scoped-store';
import * as tradeInsSelectors from '../selectors/tradeIns';
import { RSAA } from 'redux-api-middleware';
import { apiConfigHelper, locHrefUtil } from '@makemydeal/dr-shared-ui-utils';

type LienholderUpdate = Pick<
    ITradeIn,
    'lienHolder' | 'lienHolderAccountNumber' | 'lienHolderPhoneNumber' | 'lienHolderAddress' | 'perDiemInterest' | 'goodThroughDate'
> & { index: number };

export const addTradeIn = (errorIndices?: number[]) => (dispatch: any, getState: any) => {
    dispatch({ type: ADD_TRADE_IN, payload: { errorIndices } });

    const tradeIns = tradeInsSelectors.getAllTradeIns(getState());
    const newTradeInIndex = tradeIns.length - 1;

    if (newTradeInIndex >= 0) {
        dispatch(scopedActionsCreators.dispatchOnEveryScope(includeTradeChanged(true, newTradeInIndex, false)));
    }
};

export const deleteTradeIn = (index: number) => {
    return { type: DELETE_TRADE_IN, payload: index };
};

export const undoDeleteTradeIn = (index: number) => {
    return { type: UNDO_DELETED_TRADE_IN, payload: index };
};

export const toggleTradeInAccordionState = (index: number) => {
    return { type: TOGGLE_TRADE_IN_ACCORDION_STATE, payload: index };
};

export const updateTradeInDoors = (doors: string, index: number) => {
    return { type: TRADE_INS_UPDATE_DOORS, payload: { doors, index } };
};

export const updateTradeInLienholderFull = (lienHolderData: LienholderUpdate) => {
    return { type: TRADE_INS_UPDATE_LIENHOLDER_FULL, payload: lienHolderData };
};

export const updateTradeInDriveLine = (driveLine: string, index: number) => {
    return { type: TRADE_INS_UPDATE_DRIVE_LINE, payload: { driveLine, index } };
};

export const updateTradeInOdometer = (mileage: number, index: number) => {
    return { type: TRADE_INS_UPDATE_ODOMETER, payload: { mileage, index } };
};

export const updateTradeInStockNumber = (stockNumber: string, index: number) => {
    return { type: TRADE_INS_UPDATE_STOCK_NUMBER, payload: { stockNumber, index } };
};

export const updateTradeInYear = (year: string = '', index: number) => {
    return { type: TRADE_INS_UPDATE_YEAR, payload: { year, index } };
};

export const updateTradeInMake = (make: { name: string; id: string | number } = { name: '', id: '' }, index: number) => {
    return { type: TRADE_INS_UPDATE_MAKE, payload: { make: make.name, makeId: make.id, index } };
};

export const updateTradeInMakeId = (makeId: number, index: number) => {
    return { type: TRADE_INS_UPDATE_MAKE_ID, payload: { makeId, index } };
};

export const updateTradeInModel = (model: { name: string; id: string | number } = { name: '', id: '' }, index: number) => {
    return { type: TRADE_INS_UPDATE_MODEL, payload: { model: model.name, modelId: model.id, index } };
};

export const updateTradeInModelId = (modelId: number, index: number) => {
    return { type: TRADE_INS_UPDATE_MODEL_ID, payload: { modelId, index } };
};

export const updateTradeInTrim = (trim: { name: string; id: string } = { name: '', id: '' }, index: number) => {
    return { type: TRADE_INS_UPDATE_TRIM, payload: { trim: trim.name, trimId: trim.id, index } };
};

export const updateTradeInExteriorColor = (color: string, index: number) => {
    return { type: TRADE_INS_UPDATE_EXTERIOR_COLOR, payload: { color, index } };
};

export const updateTradeInCondition = (condition: string, index: number) => {
    return { type: TRADE_INS_UPDATE_CONDITION, payload: { condition, index } };
};

export const updateTradeInEngine = (engine: string, index: number) => {
    return { type: TRADE_INS_UPDATE_ENGINE, payload: { engine, index } };
};

export const updateTradeInTransmission = (transmission: string, index: number) => {
    return { type: TRADE_INS_UPDATE_TRANSMISSION, payload: { transmission, index } };
};

export const updateTradeInBodyStyle = (bodyStyle: string, index: number) => {
    return { type: TRADE_INS_UPDATE_BODY_STYLE, payload: { bodyStyle, index } };
};

export const updateTradeInInteriorColor = (interiorColor: string, index: number) => {
    return { type: TRADE_INS_UPDATE_INTERIOR_COLOR, payload: { interiorColor, index } };
};

export const updateTradeInVin = (vin: string, index: number) => {
    return { type: TRADE_INS_UPDATE_VIN, payload: { vin, index } };
};

export const tradeDetailsManualEntrySave = () => {
    return { type: TRADE_INS_DETAILS_MANUAL_ENTRY_SAVE };
};

export const includeTradeChanged = (shouldIncludeTradeIn: boolean, index: number, makePaymentCall = true) => {
    const action: TradeAction = { type: INCLUDE_TRADE_INS_CHANGED, payload: { shouldIncludeTradeIn, index } };
    if (makePaymentCall) {
        action.meta = { middleware: { payment: true } };
    }
    return action;
};

export const allowanceChanged =
    (index: number, isAllowanceSourceIndicatorEnabled: boolean = false) =>
    (value: number, skipPayment: boolean = false): TradeAction => {
        return {
            type: TRADE_INS_ALLOWANCE_CHANGED,
            payload: { value, index },
            meta: { middleware: { skipPayment }, isAllowanceSourceIndicatorEnabled }
        };
    };

export const payoffChanged =
    (index: number) =>
    (owed: number): TradeAction => {
        return { type: TRADE_INS_PAYOFF_CHANGED, payload: { owed, index } };
    };

export const acvChanged =
    (index: number) =>
    (acv: number): TradeAction => {
        return { type: TRADE_INS_ACV_CHANGED, payload: { acv, index } };
    };

export const updateTradeInIsBuyerRegisteredOwner = (isBuyerRegisteredOwner: boolean, index: number) => {
    return {
        type: TRADE_INS_UPDATE_IS_BUYER_REGISTERED_OWNER,
        payload: { isBuyerRegisteredOwner, index }
    };
};

export const updateTradeInIsSellingVehicleRegisteredInSameState = (
    isSellingVehicleRegisteredInSameState: boolean,
    index: number
) => {
    return {
        type: TRADE_INS_UPDATE_IS_SELLING_VEHICLE_REGISTERED_IN_SAME_STATE,
        payload: { isSellingVehicleRegisteredInSameState, index }
    };
};

export const updateTradeInOwnershipType = (ownershipType: string, index: number) => {
    return { type: TRADE_INS_UPDATE_OWNERSHIP_TYPE, payload: { ownershipType, index } };
};

export const vinDecodeRSAA = (appPrefix: string, vin: string, index: number, isPreserveCrmTradeVehicleInfoEnabled = false) => {
    const locHref = locHrefUtil.getLocHref();
    const bffApiUrlResult = apiConfigHelper.buildBffApiUrl(appPrefix, locHref, '/trade');
    const endpoint = bffApiUrlResult.url + `/vin/decode/${vin}`;

    const meta = { index, isPreserveCrmTradeVehicleInfoEnabled };
    return {
        [RSAA]: {
            endpoint,
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
            types: [
                { type: TRADE_INS_VIN_REQUEST, meta },
                { type: TRADE_INS_VIN_SUCCESS, meta },
                { type: TRADE_INS_VIN_FAILURE, meta }
            ]
        }
    };
};

export const selectMultipleVinOption = (option: any, index: number, isPreserveCrmTradeVehicleInfoEnabled = false) => {
    return {
        type: TRADE_INS_MULTIPLE_VIN_SELECTED,
        payload: { option, index },
        meta: { isPreserveCrmTradeVehicleInfoEnabled }
    };
};

export const updateVehicle = (vehicle: any, index: number) => {
    return {
        type: TRADE_INS_COMPONENT_UPDATE_VEHICLE,
        payload: { vehicle, index }
    };
};

export const fetchTradeInComponentMakes = (appPrefix: string, year: string, index: number) => {
    const locHref = locHrefUtil.getLocHref();
    const bffApiUrlResult = apiConfigHelper.buildBffApiUrl(appPrefix, locHref, '/trade');
    const searchParams = {
        year,
        vehicleClass: 'used'
    };
    const queryString = new URLSearchParams(searchParams).toString();
    const endpoint = bffApiUrlResult.url + `/lookup/makes?${queryString}`;

    const meta = { index };

    return {
        [RSAA]: {
            endpoint,
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
            types: [
                { type: TRADE_INS_MAKES_REQUEST, meta },
                { type: TRADE_INS_MAKES_SUCCESS, meta },
                { type: TRADE_INS_MAKES_FAILURE, meta }
            ]
        }
    };
};

export const fetchTradeInComponentVehicle = (
    appPrefix: string,
    year: string,
    makeId: string,
    modelId: string,
    trimId: string,
    index: number
) => {
    const locHref = locHrefUtil.getLocHref();
    const bffApiUrlResult = apiConfigHelper.buildBffApiUrl(appPrefix, locHref, '/trade');
    const searchParams = {
        year,
        makeid: makeId,
        modelid: modelId,
        trimid: trimId
    };
    const queryString = new URLSearchParams(searchParams).toString();
    const endpoint = bffApiUrlResult.url + `/lookup/vehicles?${queryString}`;
    const meta = { index };

    return {
        [RSAA]: {
            endpoint,
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
            types: [
                { type: TRADE_INS_VEHICLES_REQUEST, meta },
                { type: TRADE_INS_VEHICLES_SUCCESS, meta },
                { type: TRADE_INS_VEHICLES_FAILURE, meta }
            ]
        }
    };
};

export const fetchTradeInComponentModels = (appPrefix: string, year: string, id: string, index: number) => {
    const locHref = locHrefUtil.getLocHref();
    const bffApiUrlResult = apiConfigHelper.buildBffApiUrl(appPrefix, locHref, '/trade');
    const searchParams = {
        year,
        makeid: id,
        vehicleClass: 'used'
    };
    const queryString = new URLSearchParams(searchParams).toString();
    const endpoint = bffApiUrlResult.url + `/lookup/models?${queryString}`;
    const meta = { index };

    return {
        [RSAA]: {
            endpoint,
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
            types: [
                { type: TRADE_INS_MODELS_REQUEST, meta },
                { type: TRADE_INS_MODELS_SUCCESS, meta },
                { type: TRADE_INS_MODELS_FAILURE, meta }
            ]
        }
    };
};

export const fetchTradeInComponentTrims = (appPrefix: string, year: string, makeId: string, modelId: string, index: number) => {
    const locHref = locHrefUtil.getLocHref();
    const bffApiUrlResult = apiConfigHelper.buildBffApiUrl(appPrefix, locHref, '/trade');
    const searchParams = {
        year,
        makeid: makeId,
        modelid: modelId,
        vehicleClass: 'used'
    };
    const queryString = new URLSearchParams(searchParams).toString();
    const endpoint = bffApiUrlResult.url + `/lookup/trims?${queryString}`;
    const meta = { index };

    return {
        [RSAA]: {
            endpoint,
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
            types: [
                { type: TRADE_INS_TRIMS_REQUEST, meta },
                { type: TRADE_INS_TRIMS_SUCCESS, meta },
                { type: TRADE_INS_TRIMS_FAILURE, meta }
            ]
        }
    };
};
